// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"80d6f8ba","96":"ae51418d","150":"54dcb55a","206":"8f42413e","258":"f38af587","322":"548ec843","370":"b48fc881","474":"dacd50e9","582":"4fab061d","604":"7fc22ad9","612":"bf172af1","654":"e218b2f9","791":"319f8594","980":"e48501fa"}[chunkId] + ".chunk.css";
};